/**
 * Configuración del basemap (capa de tiles del mapa).
 *
 * Se volvió configurable porque CARTO cambió su política: el basemap
 * oscuro que usábamos sin llave ahora responde HTTP 200 pero con las
 * tiles MARCADAS con "API KEY REQUIRED" — no falla, se ve mal, que es
 * peor porque no dispara ninguna alarma automática.
 *
 * Con esto la llave (o un proveedor distinto) se cambia desde una
 * variable de entorno en Vercel, sin tocar código ni redeployar a mano.
 *
 *   VITE_MAP_TILE_URL          URL de tiles con placeholders de Leaflet
 *                              ({z}/{x}/{y}, opcional {s} y {r}).
 *                              Para CARTO con llave, agrega ?api_key=...
 *   VITE_MAP_TILE_ATTRIBUTION  Atribución legal del proveedor. Cambiarla
 *                              junto con la URL: es requisito de licencia
 *                              de casi todos los proveedores de tiles.
 *
 * El `.trim()` no es adorno: la variable del API ya venía con un salto de
 * línea desde Vercel (ver `lib/api.ts`), y aquí rompería la URL entera.
 */

const DEFAULT_URL = 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png';
const DEFAULT_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &middot; CARTO';

function envStr(v: unknown, fallback: string): string {
  const s = typeof v === 'string' ? v.trim() : '';
  return s.length > 0 ? s : fallback;
}

export const BASEMAP_URL = envStr(import.meta.env.VITE_MAP_TILE_URL, DEFAULT_URL);
export const BASEMAP_ATTRIBUTION = envStr(
  import.meta.env.VITE_MAP_TILE_ATTRIBUTION,
  DEFAULT_ATTRIBUTION,
);

/**
 * Leaflet solo usa `subdomains` cuando la URL trae `{s}`. Si el
 * proveedor nuevo no lo usa (lo normal fuera de CARTO/OSM), pasar la
 * lista es ruido — devolvemos undefined y el prop se omite.
 */
export const BASEMAP_SUBDOMAINS = BASEMAP_URL.includes('{s}') ? 'abcd' : undefined;
